import Button from '@/UI/Button'
import { styled } from 'config/stitches.config'

export const StyledVideoEmbedContainer = styled('div', {
  display: 'block',
  width: '100%',
  maxWidth: '1180px',
  margin: '0 auto',
  aspectRatio: 'auto 16 / 9',
  variants: { isMobile: { true: { aspectRatio: 'auto 9 / 16', } } },
  borderRadius: 40,
  overflow: 'hidden',
  position: 'relative',
})

export const StyledVideoEmbedPreview = styled('div', {
  position: 'relative',
  zIndex: 1,
  width: '100%',
  height: '100%',

  img: { objectFit: 'cover' }
})

export const StyledVideoEmbedPreviewButton = styled(Button, {
  aspectRatio: '1 / 1',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
})

export const StyledVideoEmbedContent = styled('div', {
  position: 'absolute',
  width: '100%',
  height: '100%',
  zIndex: 0,
  top: 0,
  left: 0,

  div: {
    position: 'relative',
    width: '100%',
    height: '100%',

    iframe: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
    }
  }
})
